import { ToolBarContainer, } from "./styled";
import BarekamButton, { ActionbarButtons, OrderButtons } from "../../../components/button";
import React, { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../redux/store";
import { BarekamIcon, IconVariants } from "../../../components/icon/barekam-icon";
import { changeFilter, changeOrderView, getOrders } from "../../../../redux/slices/orders-slice";
import { OrderFilterModel } from "../../../shared/models/order/order-filter.model";
import { Message, MessageSections } from "../../../components/message/message";
import BarekamText from "../../../components/text";
import { AttachmentIcons, OrderIcons } from "../../../components/icon/variants";
import { Divider, Tab, Tabs } from "@mui/material";
import ToolPanelButtons from "./tool-panel-buttons/tool-panel-buttons";
import { OrderFilter } from "./filter/order-filter";
import { ToolPanelActions } from "../../../../management-pages/actions/action-buttons";
import { ToolPanelActionsByState } from "../../../../management-pages/actions/actions-by-state";
import {
    GenericActionTypes,
    InWarehouseActionTypes,
    OrderPopupActionTypes,
    ReadyForShipmentActionTypes
} from "../../../../management-pages/actions/action-types.enum";
import { ToolPanelProps } from "./tool-panel";
import { OrderViewEnum } from "../../enums/order/view.enum";
import { statesWithLocation, statesWithTabs } from "../../../../constants";
import { OrderStatesEnum } from "../../enums/order-states.enum";
import { exportToExcel } from "../../../shared/helper-functions";
import { SearchInput } from "./filter/search-input";

export const WarehouseWorkerToolPanel = ({ selectedOrders, setActiveAction, orderStateId, exportableOrders, inCustomerOrdersPage }: ToolPanelProps) => {
    const { filter, orderViewType } = useAppSelector(state => state.ordersReducer);

    const { matchesPhone } = useAppSelector(state => state.deviceReducer);

    const [mobileFilterOpened, setMobileFilterOpened] = useState(false);

    const { orderStates, currentRate } = useAppSelector(state => state.staticDataReducer);


    const dispatch = useAppDispatch();

    function onToolbarAction(actionType: InWarehouseActionTypes | ReadyForShipmentActionTypes | OrderPopupActionTypes) {
        setActiveAction && setActiveAction(actionType);
    }

    function changeTab(view: OrderViewEnum) {
        dispatch(changeOrderView(view));
    }

    function onExport() {
        let fileName = '';
        if (typeof orderStateId === 'number') {
            fileName = orderStates.find(state => state.orderStateId === orderStateId)?.name || '';
        } else {
            fileName = orderStateId || '';
        }
        const data = !!selectedOrders && selectedOrders.size ? selectedOrders :
            (!!exportableOrders && exportableOrders.length ? exportableOrders : []);
        exportToExcel(fileName, data, currentRate);
    }

    function handleFilterChange(modifiedFilter: OrderFilterModel) {
        dispatch(changeFilter(modifiedFilter));

        if (!inCustomerOrdersPage) {
            dispatch(getOrders({ page: 0 }));
        }
    }

    return (
        <>
            {orderStateId && statesWithTabs.includes(orderStateId)
                ? <Tabs value={orderViewType}>
                    <Tab value={OrderViewEnum.list}
                        key={OrderViewEnum.list}
                        label={
                            <Message messageKey={'orders'} sectionId={MessageSections.ORDERS} />}
                        onClick={() => changeTab(OrderViewEnum.list)}
                    />
                    <Tab value={OrderViewEnum.cards}
                        key={OrderViewEnum.cards}
                        label={
                            <Message messageKey={'groups'} sectionId={MessageSections.ORDERS} />}
                        onClick={() => changeTab(OrderViewEnum.cards)}
                    />

                    {statesWithLocation.includes(orderStateId) &&
                        <Tab value={OrderViewEnum.location}
                            key={OrderViewEnum.location}
                            label={
                                <Message messageKey={'location'} sectionId={MessageSections.ORDERS} />}
                            onClick={() => changeTab(OrderViewEnum.location)}
                        />
                    }
                </Tabs>
                : ''
            }

            <ToolBarContainer style={{ paddingTop: '1rem' }}>
                {orderViewType === OrderViewEnum.list
                    ? <>
                        <OrderFilter onFilterChange={handleFilterChange}
                            mobileFilterOpened={mobileFilterOpened}
                            setMobileFilterOpened={setMobileFilterOpened} />
                        {matchesPhone ? '' : <Divider style={{ width: '100%' }} />}
                    </>
                    : ''
                }

                <div style={{ display: 'flex', justifyContent: 'space-between', gap: '0.5rem', overflowX: 'auto' }}>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                        <SearchInput filter={filter} filterChanged={handleFilterChange} />

                        {inCustomerOrdersPage
                            ? ''
                            : <>

                                {orderStateId === OrderStatesEnum.readyForPickup ?
                                    <BarekamButton type={ActionbarButtons.NEW} size={"s"}
                                        onClick={() => setActiveAction && setActiveAction(InWarehouseActionTypes.READY_FOR_PICKUP)}>
                                        <BarekamIcon variant={OrderIcons.scanOrder} />
                                        <BarekamText variant={'m'} bold>
                                            <Message messageKey={'scan_orders'} sectionId={MessageSections.ORDERS} />
                                        </BarekamText>
                                    </BarekamButton> : ''
                                }
                                {orderStateId !== OrderStatesEnum.readyForPickup ?
                                    <BarekamButton type={ActionbarButtons.NEW} size={"s"}
                                        onClick={() => setActiveAction && setActiveAction(GenericActionTypes.SCAN_FOR_SEARCH)}>
                                        <BarekamIcon variant={OrderIcons.scanOrder} />
                                        <BarekamText variant={'m'} bold>
                                            <Message messageKey={'scan_orders'} sectionId={MessageSections.ORDERS} />
                                        </BarekamText>
                                    </BarekamButton> : ''
                                }

                                {orderStateId === OrderStatesEnum.inWarehouse
                                    ? <BarekamButton type={ActionbarButtons.NEW} size={"s"}
                                        onClick={() => setActiveAction && setActiveAction(GenericActionTypes.CREATE_GROUP)}>
                                        <BarekamIcon variant={IconVariants.plus}
                                            size={{ width: '1rem', height: '1rem' }} />

                                        <BarekamText variant={'m'} fontWeight={700}>
                                            <Message messageKey={'create_group'}
                                                sectionId={MessageSections.ORDERS} />
                                        </BarekamText>
                                    </BarekamButton>
                                    : ''
                                }
                            </>
                        }
                    </div>

                    <div style={{ display: 'flex' }}>
                        {!inCustomerOrdersPage && !!selectedOrders && selectedOrders.size
                            ?
                            <ToolPanelActions actions={orderStateId ? ToolPanelActionsByState[orderStateId] : undefined}
                                onClick={onToolbarAction}
                            />
                            : ''
                        }

                        {
                            (!!selectedOrders && selectedOrders.size) || (!!exportableOrders && exportableOrders.length) ?
                                <BarekamButton type={OrderButtons.EXPORT} size={"s"} onClick={onExport}>
                                    <BarekamIcon variant={AttachmentIcons.download} />

                                    <BarekamText variant={"m"} bold>
                                        <Message messageKey={"export"} sectionId={MessageSections.ORDERS} />
                                    </BarekamText>
                                </BarekamButton>
                                : ''
                        }

                        <ToolPanelButtons isWarehouseWorker={true} onFilterClicked={() => setMobileFilterOpened(true)} />
                    </div>
                </div>
            </ToolBarContainer>
        </>
    )
}
